// ===== Footer Accordion with Custom SVG Arrow (Mobile Only) =====
document.addEventListener("DOMContentLoaded", function () {
  const columns = Array.from(document.querySelectorAll(".footer-columns .footer-column"))
    .slice(0, 3); // only first 3 columns (Shop, Story, Support)

  const arrowURL = "https://cdn.shopify.com/s/files/1/0676/8295/9491/files/arrow.svg?v=1759840864";

  function setupAccordion() {
    if (window.innerWidth <= 768) {
      columns.forEach(col => {
        const heading = col.querySelector(".footer-column-heading");
        const menu = col.querySelector(".footer-menu");
        if (!heading || !menu) return;

        // Add arrow icon if not already added
        if (!heading.querySelector(".accordion-icon")) {
          const img = document.createElement("img");
          img.src = arrowURL;
          img.alt = "Toggle";
          img.className = "accordion-icon";
          heading.appendChild(img);
        }

        // Avoid duplicate event binding
        if (heading.dataset.bound) return;
        heading.dataset.bound = "1";

        // Toggle open/close
        heading.addEventListener("click", () => {
          col.classList.toggle("is-open");
        });

        // Start collapsed
        col.classList.remove("is-open");
      });
    } else {
      // Reset on desktop
      columns.forEach(col => col.classList.add("is-open"));
    }
  }

  setupAccordion();
  window.addEventListener("resize", setupAccordion);
});
